import { IWarningMessageStyle } from '../models/index.js';
export const warningMessageStyle: IWarningMessageStyle = {
	text: {
		align: 'center',
	},
	box: {
		sizing: 'inherit',
	},
	font: {
		family: '"DM Sans", sans-serif',
		weight: '400',
		size: '13px',
	},
	color: '#FFA500',
	margin: {
		_value: '0px',
	},
};
